import { Button, Menu, MenuItem } from "@mui/material";
import { useState } from "react";
import { Eye, Mail, MapPin, MoreVertical, Printer, X } from "react-feather";
import { Link } from 'react-router-dom';

const ActionItem = ({ tableProps, setDetailsModalShow, setCurrentItem, setCurrentItemStr, sendMailBooking, downloadItemList, setDeleteModalShow, setModalShow }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    return <>
        <Button onClick={(e) => { setAnchorEl(e.currentTarget); }}><MoreVertical /></Button>
        <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={(e) => setAnchorEl(null)}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
            <MenuItem onClick={(e) => { setAnchorEl(null); setDetailsModalShow(true); setCurrentItem(tableProps?.id); setCurrentItemStr(tableProps?.reference_id); }}><Eye /> View</MenuItem>
            <MenuItem onClick={(e) => { setAnchorEl(null); sendMailBooking(tableProps?.id); }}><Mail /> Send Mail</MenuItem>
            <MenuItem onClick={(e) => { setAnchorEl(null); downloadItemList(tableProps?.id); }}><Printer /> Print</MenuItem>
            <MenuItem onClick={(e) => { setAnchorEl(null); setModalShow(true); setCurrentItem(tableProps?.id); }}><X /> Cancel</MenuItem>
            <MenuItem onClick={(e) => { setAnchorEl(null); }}><Link as={Button} to={'/admin/booking/enquery/' + tableProps?.reference_id}><MapPin /> Equiry</Link></MenuItem>
        </Menu>
    </>
}

export default ActionItem;